import { TransitionsOptions } from '@material-ui/core/styles';

export const TRANSITION_THEME_OPTIONS: TransitionsOptions = {
  duration: {
    short: 0.1,
    standard: 0.3,
  },
};
